



//请求是否白条用户
export const REC_ISBAI = 'REC_ISBAI';

//处理是否白条用户
export const HANDLE_ISBAI = 'HANDLE_ISBAI';